import { DEMO_DRIVERS_TABLE } from './data.js';

type Handler = (payload: unknown) => void;

interface DemoSocketShape {
  on: (event: string, handler: Handler) => DemoSocketShape;
  off: (event: string, handler?: Handler) => DemoSocketShape;
  emit: (event: string, payload?: unknown) => DemoSocketShape;
  disconnect: () => void;
}

const ACTIVE = DEMO_DRIVERS_TABLE.filter(
  (d) => (d.status === 'online' || d.status === 'on_trip') && d.lat != null && d.lng != null,
);

const wanderState = ACTIVE.map((d) => ({
  id: d.id,
  lat: d.lat as number,
  lng: d.lng as number,
  bearing: Math.random() * Math.PI * 2,
}));

export function createDemoSocket(): DemoSocketShape {
  const handlers = new Map<string, Set<Handler>>();
  let ticker: ReturnType<typeof setInterval> | null = setInterval(() => {
    const fns = handlers.get('driver:location');
    if (!fns?.size) return;
    for (const driver of wanderState) {
      driver.bearing += (Math.random() - 0.5) * 0.6;
      driver.lat += Math.cos(driver.bearing) * 0.0006;
      driver.lng += Math.sin(driver.bearing) * 0.0006;
      const payload = {
        driverId: driver.id,
        position: { lat: driver.lat, lng: driver.lng },
        heading: (driver.bearing * 180) / Math.PI,
        at: new Date().toISOString(),
      };
      fns.forEach((fn) => fn(payload));
    }
  }, 3500);

  const socket: DemoSocketShape = {
    on(event, handler) {
      let set = handlers.get(event);
      if (!set) {
        set = new Set();
        handlers.set(event, set);
      }
      set.add(handler);
      return socket;
    },
    off(event, handler) {
      if (!handler) handlers.delete(event);
      else handlers.get(event)?.delete(handler);
      return socket;
    },
    emit() {
      return socket;
    },
    disconnect() {
      if (ticker) clearInterval(ticker);
      ticker = null;
      handlers.clear();
    },
  };
  return socket;
}
